import {CommonModule, DatePipe} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MaterialModule} from '../../module/material.module';

@Component({
  selector: 'app-slicemenu',
  standalone: true,
  imports: [CommonModule, TranslateModule, MaterialModule],
  providers: [DatePipe],
  templateUrl: './slicemenu.component.html',
  styleUrl: './slicemenu.component.scss'
})
export class SlicemenuComponent {
  @Input() DataList: any[] = [];
  @Input() selected?: any;
  @Input() columnName: string = '';
  @Input() columns: string[] = [];
  @Output() newItemEvent = new EventEmitter<any>();
  isExpanded: boolean = false;
constructor(private datePipe: DatePipe) {
}
  expandItems() {
    this.isExpanded = !this.isExpanded;
  }

  Show(data: any) {
    this.newItemEvent.emit(data);
  }

  DisplayData(data: any, column: string) {
    let value = data[column];
    return value instanceof Date? this.datePipe.transform(value, 'dd/MM/YYYY') : value;
  }
}
